module.exports = __webpack_public_path__ + "img/castalis_slim_balanced.51081cdd.jpg";